import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=fd742040&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd742040')) {
      api.createRecord('fd742040', component.options)
    } else {
      api.reload('fd742040', component.options)
    }
    module.hot.accept("./GameList.vue?vue&type=template&id=fd742040&", function () {
      api.rerender('fd742040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameList.vue"
export default component.exports